import React, { Component } from 'react';



class TaxesModal extends Component {

    render() {
        const {taxList, newOrderModel, ChangeTaxCode, iItemTax} = this.props;
        const item = newOrderModel?.Items[iItemTax] || null;

        return (
            <div>
                <div className="modal fade" id="taxesModal" data-keyboard="false" tabIndex="-1" aria-labelledby="taxesModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-body">
                                <div className="m-5">
                                    <select 
                                        className="form-control text-center mb-3" 
                                        style={{backgroundColor:"#343a40", color:"white",fontSize:18}}
                                        value = {item ? item.TaxCode : newOrderModel.TaxCode}
                                        onChange={(event)=>{ChangeTaxCode(event.target.value)}} >
                                            
                                        <option value=''>TAX</option>
                                        {taxList.map((tax)=>{
                                            return(
                                                <option value={tax.Code}>{tax.Name}</option>
                                            )
                                        })}
                                    </select>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td>Impuesto:</td>
                                                <td align="right">{item ? item.TaxeResult : newOrderModel.Taxes}</td>
                                            </tr>
                                            <tr>
                                                <td>Subtotal:</td>
                                                <td align="right">{item ? item.Total : newOrderModel.Subtotal}</td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                            
                                        </tbody>
                                        <tfoot>
                                            
                                            <tr style={{ fontSize: 16 }}>
                                                <td>TOTAL</td>
                                                <td align="right">{item ? item.TotalAndTax : newOrderModel.Total}</td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default TaxesModal;